import theme from "assets/theme";
import React, { useEffect, useRef } from "react";
import { Animated, Dimensions, StyleSheet, Text } from "react-native";

const classes = StyleSheet.create({
  root: {
    backgroundColor: theme.color.background,
    borderRadius: 5,
    padding: 10,
    width: 300,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
});

export default function Toast(props) {
  const { toast, onHide } = props;

  const translateY = useRef(new Animated.Value(100)).current;
  const translateX = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    // Slide in from bottom
    Animated.timing(translateY, {
      toValue: 0,
      duration: 200,
      useNativeDriver: false,
    }).start();

    // Slide out to right after 4 seconds
    const timer = setTimeout(() => {
      Animated.timing(translateX, {
        toValue: Dimensions.get("window").width,
        duration: 300,
        useNativeDriver: false,
      }).start(() => {
        onHide();
      });
    }, 4000);

    return () => clearTimeout(timer);
  }, [onHide, translateX, translateY]);

  return (
    <Animated.View
      style={{
        ...(toast.type in theme.color.toast
          ? {
              ...classes.root,
              backgroundColor: theme.color.toast[toast.type],
            }
          : classes.root),
        transform: [{ translateY }, { translateX }],
      }}
    >
      <Text>{toast.message}</Text>
    </Animated.View>
  );
}
